import React, { useContext, useEffect } from 'react'
import Nav from './nav'
import { Row, Col, Container } from 'react-bootstrap'
import styles from './layout.module.css'
import { AuthContext, AuthState, UserType } from '../../../contexts/authContext'
import Header from './header'
import Footer from './footer'
import { useLocation } from 'react-router'

export interface LayoutProps {
  children: React.ReactNode
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const authContext = useContext(AuthContext)
  const isSignedIn = authContext?.authState === AuthState.signedIn
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return (
    <>
      <Container fluid className={styles.mainContainer}>
        <Row>
          {isSignedIn ? (
            <Col md="12" lg="2" className="pl-lg-0">
              <Nav />
            </Col>
          ) : (
            <Col xs="12">
              <Nav />
            </Col>
          )}
          <Col
            xs="12"
            lg={isSignedIn ? 10 : 12}
            className={isSignedIn ? styles.mainContent : ''}
          >
            {(authContext?.userType === UserType.migrant || !isSignedIn) && (
              <div className="d-none d-lg-block">
                <Header />
              </div>
            )}
            <div className={styles.contentWrapper}>{children}</div>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  )
}

export default Layout
